<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div>
        <p class="modalTitle">事業者詳細 - {{name}}</p>
        <!-- ローディング -->
        <div v-if="getLodingFlg">
          <vue-loading
            type="cylon"
            color="#1b7e47"
            :size="{ width: '150px', height: '150px' }"
          >
          </vue-loading>
          <div v-if="getLodingFlg" style="padding: 0px 0px 30px 0px;">Now loading...</div>
        </div>
        <!-- 取得エラー表示 -->
        <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
          <div　class="errMsg">
            <div class="errSpan" style="font-size:x-large;">
              {{errorMessage}}
            </div>
          </div>
        </div>
        <form v-if="!getLodingFlg && !getErrorFlg">
          <!-- 作業者情報 -->
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              事業者情報
            </div>

            <div class="row">
              <p class="inputTitle editable">内部ID</p>
              <div class="rowRight">
                <input class="text large" v-model="companyId" readonly>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">ログインID</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.loginId" readonly>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">メールアドレス </p>
              <div class="rowRight">
                <input class="text large" v-model="detail.email" readonly>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">事業者名</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.companyName" readonly>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">登録日</p>
              <div class="rowRight">
                <input class="text large" type="date" v-model="detail.createdAt" readonly>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">利用規約同意日</p>
              <div class="rowRight">
                <input class="text large" type="date" v-model="detail.termConsent" readonly>
              </div>
            </div>
            <div class="row">
              <button class="edit" @click="accessLog" type="button">アクセスログ
              </button>
              <button class="edit" @click="loginLog" type="button">ログイン履歴
              </button>
            </div>
          </div>
          <!-- 作業者情報 -->
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              事業者情報
            </div>
            <div class="row">
              <p class="inputTitle editable">CCUS事業者ID</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.ccusCompanyId" readonly v-if="detail.ccusCompanyId">
                <input class="text large" value="登録なし" readonly v-else>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">法人番号</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.corporationNo" readonly v-if="detail.corporationNo">
                <input class="text large" value="登録なし" readonly v-else>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">建設業許可番号</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.constructionNo" readonly v-if="detail.constructionNo">
                <input class="text large" value="登録なし" readonly v-else>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">事業者名</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.companyName" readonly v-if="detail.companyName">
                <input class="text large" value="登録なし" readonly v-else>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">代表者名</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.responsibleName" readonly v-if="detail.responsibleName">
                <input class="text large" value="登録なし" readonly v-else>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">担当者部署/役職</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.personDivision" readonly v-if="detail.personDivision">
                <input class="text large" value="登録なし" readonly v-else>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">担当者名</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.personName" readonly v-if="detail.personName">
                <input class="text large" value="登録なし" readonly v-else>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">担当者連絡先</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.personTel" readonly v-if="detail.personTel">
                <input class="text large" value="登録なし" readonly v-else>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import { VueGoodTable } from 'vue-good-table';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';
import common from '../services/common';

export default {
  title: '事業者詳細',
  name: 'BusinessEdit',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueGoodTable,
    VueLoading,
  },
  props: {
    companyId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: '',
      required: true,
    },
  },
  // setup() {
  //   return {
  //   },
  // },
  data() {
    return {
      modal: false,
      detail: {
        // ユーザー情報
        loginId: '',
        email: '',      // メールアドレス
        companyName: '',   // 事業者名
        createdAt: '',     // 登録日
        termConsent: '',    // 利用規約同意日

        // 事業者情報
        ccusCompanyId: '',     // CCUSID
        corporationNo: '',          // 法人番号
        constructionNo: '',             // 建設業許可番号
        responsibleName: '',           // 代表者名
        personDivision: '',          // 担当者部署/役職
        personName: '',              // 担当者名
        personTel: '',           // 担当者連絡先
      },
      // ローディング
      getLodingFlg: true,  // データ取得時ローディング用フラグ
      getErrorFlg: false,   // データ取得時エラーフラグ
      errorMessage: '',
    };
  },
  // 初期処理
  async mounted() {
    try {
      // 事業者一意情報取得API呼出
      await this.callGetCompany();
      // await new Promise((resolve) => setTimeout(resolve, 300));
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // 事業者一意情報取得API呼出
    async callGetCompany() {
      try {
        const restResourceService = new ApiClient();
        const result = await restResourceService.getCompany(this.companyId);
        result.personName = result.personFirstName + result.personLastName;
        result.createdAt = common.dateFormatHyphen(result.createdAt);
        result.termConsent = common.dateFormatHyphen(result.createdAt);
        this.detail = result;
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        throw error;
      }
    },
    // 技能者一覧画面へ戻る
    businessList() {
      history.back();
    },
    // アクセスログ
    accessLog() {
      this.$router.push({
        name: 'AccessLog',
        params: {
          id: this.detail.loginId,
        },
      });
    },
    // ログイン履歴
    loginLog() {
      this.$router.push({
        name: 'LoginLog',
        params: {
          id: this.detail.loginId,
        },
      });
    },
    // CCUSID修正
    async ccusCompanyIdChange() {
      try {
        const restResourceService = new ApiClient();
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        throw error;
      }
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";
.selectdiv {
  position: relative;
  float: left;
  min-width: 95%;
}

.selectdiv:after {
  content: '>';
  font: 17px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;
  top: 18px;
  padding: 0 0 2px;
  border-bottom: 1px solid #999;
  position: absolute;
  pointer-events: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Add some styling */

  display: block;
  width: 100%;
  max-width: 494px;
  height: 45px;
  float: right;
  margin: 5px 0px;
  padding: 0px 20px;
  font-size: 20px;
  line-height: 1.75;
  color: #333;
  background-color: #ffffff;
  background-image: none;
  border: 2px solid #000000;
  border-radius:10px;
  -ms-word-break: normal;
  word-break: normal;
}
.modalTitle {
  margin: 30px auto;
  font-weight: bold;
  font-size: $font-medium;
  color: $font_color;
}
.logoutYes {
  background-color: $button-primary;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  margin-bottom: 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
.logoutNo {
  background-color: $button-danger;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
</style>
